import { getContentPath } from './utils';

const getFill = (table, cell, content, canvasState) => {
    const oldShape = canvasState.getIn(getContentPath(table, cell, content, canvasState));
    return oldShape.toJS().fill;
};

export default getFill;
